import { canUseDOM } from '@/app/common/utils/canUseDOM';

export const showMoreToggle = (show: boolean): void => {
  if (canUseDOM) {
    const discoverElement = document.getElementsByClassName('openx-ui-discover')[0] as HTMLDivElement;
    if (discoverElement) {
      if (show) {
        discoverElement.classList.add('openx-ui-discover-show');
      } else {
        discoverElement.classList.remove('openx-ui-discover-show');
      }
    }
  }
};
